export const SUPABASE_CONFIG = {
  ENDPOINT: "https://tfcrcoqvdowylhfnnnzo.supabase.co",
  PUBLIC_API_KEY: "sb_publishable_W7KrCGJ-B2L3Jai0JZy-2Q_gD2SkfTl",
};
